import Vue from 'vue'
import VueRouter from 'vue-router'
import { getDefaultRoute } from '@/config/menus'
import energyQuery from './modules/energyQuery'
import energyFlow from './modules/energyFlow'
import carbonAccounting from './modules/carbonAccounting'
import carbonAsset from './modules/carbonAsset'
import carbonFootprint from './modules/carbonFootprint'

Vue.use(VueRouter)

const defaultRoute = getDefaultRoute()

const routes = [
  {
    path: '/',
    redirect: defaultRoute
  },
  energyQuery,
  energyFlow,
  carbonAccounting,
  carbonAsset,
  carbonFootprint,
  {
    path: '*',
    redirect: defaultRoute
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
